import { render, staticRenderFns } from "./leaveView.vue?vue&type=template&id=8d22b24a&scoped=true"
import script from "./leaveView.vue?vue&type=script&lang=js"
export * from "./leaveView.vue?vue&type=script&lang=js"
import style0 from "./leaveView.vue?vue&type=style&index=0&id=8d22b24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d22b24a",
  null
  
)

export default component.exports